import { useAppDispatch, useAppSelector } from "../../utils/redux/hooks";
import { getFAQ } from "../../utils/apis/func";
import { addfaq } from "../../utils/redux/mainSlice";
import { RootState } from "../../utils/redux/store";

import React, { useState, useEffect } from "react";
import Privacy from "../helpers/settingTabs/privacy";
import CustomerTerms from "../helpers/settingTabs/customerTerms";
import SpRating from "../helpers/settingTabs/spRating";
import CustomerRating from "../helpers/settingTabs/customerRating";
import Faq from "../helpers/settingTabs/faq";
import General from "../helpers/settingTabs/general";
import SPPolicyContent from "../helpers/settingTabs/spTerms";
import TwoFactor from "../helpers/settingTabs/twoFactor";

const items = [
  "Privacy Policy - Customer",
  "Privacy Policy - SP",
  "Terms and Conditions ",
  "SP - Rating",
  "Customer - Rating",
  "FAQ",
  "General",
  "Two Factor",
];

const SettingsContent = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const dispatch = useAppDispatch();
  const faq = useAppSelector((store: RootState) => store.user.faq);
  console.log(faq);

  useEffect(() => {
    const fetchFaq = async () => {
      const res: any = await getFAQ("");
      console.log("faq here", res?.data);
      if (res?.status === 200 || res?.status === 201) {
        dispatch(addfaq(res?.data?.data));
      }
    };
    fetchFaq();
  }, [dispatch]);

  return (
    <div className="">
      <section className="flex px-1 lg:px-8 mt-2 mb-6 lg:justify-between xl:justify-between overflow-x-auto lg:overflow-hidden max-w-screen-sm lg:max-w-screen-xlg mx-auto lg:mx-0">
        {items.map((item, index) => (
          <p
            key={index}
            className={`bg-[#fff] py-2 px-6 w-max whitespace-nowrap sm:rounded-0 sm:mr-4 lg:mr-0 lg:rounded-full text-center font-outfit text-sm font-medium leading-normal tracking-tighter cursor-pointer border ${
              index === selectedTab ? "border-[#88087B]" : ""
            }`}
            onClick={() => setSelectedTab(index)}
          >
            {item}
          </p>
        ))}
      </section>
      {items.map((item, index) => (
        <div
          key={index}
          style={{
            display: index === selectedTab ? "block" : "none",
          }}
        >
          {/*privacy policy for sp */}
          {index === 1 && <SPPolicyContent />}
          {/* terms and condition */}
          {index === 2 && <Privacy />}
          {/*privacy policy for customer */}
          {index === 0 && <CustomerTerms />}
          {/*spRating */}
          {index === 3 && <SpRating />}
          {/*privacy policy for customer */}
          {index === 4 && <CustomerRating />}
          {index === 5 && <Faq />}
          {index === 6 && <General />}
          {index === 7 && <TwoFactor />}
        </div>
      ))}
    </div>
  );
};

export default SettingsContent;
